import {
  LienholderRequirement,
  LienholderSlugEnum,
  StateAbbreviation,
} from '../gql/generated/graphql';

export const OtherLienholder = 'Other';
export const OtherLienholderSlug = OtherLienholder.toLowerCase();

export const lienholderDisplayName = (name?: string | null): string =>
  name && name !== OtherLienholder ? name : 'your lender';

export type LienholderOtherSource = {
  lienholder?: string | null;
  lienholder_slug?: string | null;
  is_core?: boolean | null;
};

export const isTreatedAsOther = (data?: LienholderOtherSource | null): boolean =>
  data?.lienholder === OtherLienholder ||
  data?.lienholder_slug === OtherLienholderSlug ||
  data?.is_core === false;

export const usBankSlug = 'us_bank';
const nissanFinanceSlug = 'nissan_finance';
const teslaFinanceSlug = 'tesla_finance';

export const NOT_AVAILABLE_LIENHOLDERS_PER_STATE: Partial<Record<StateAbbreviation, string[]>> = {
  [StateAbbreviation.Hi]: [nissanFinanceSlug],
  [StateAbbreviation.Ia]: [teslaFinanceSlug],
  [StateAbbreviation.La]: [teslaFinanceSlug],
};

export const FALLBACK_PAYOFF_CREDENTIALS: Partial<Record<string, LienholderRequirement[]>> = {
  [LienholderSlugEnum.BmwFs]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.MiniFs]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.MercedesBenzFs]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.UsBank]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.VolvoCarFs]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.StellantisFinancialServicesInc]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.SubaruMotorFinance]: [LienholderRequirement.LastFourSsn],
  [LienholderSlugEnum.KiaFinance]: [LienholderRequirement.Ssn, LienholderRequirement.Dob],
  [LienholderSlugEnum.HyundaiMotorFinance]: [LienholderRequirement.Ssn, LienholderRequirement.Dob],
  [LienholderSlugEnum.GenesisFinance]: [LienholderRequirement.Ssn, LienholderRequirement.Dob],
  [LienholderSlugEnum.GmFinancial]: [LienholderRequirement.Ssn, LienholderRequirement.Dob],
  [LienholderSlugEnum.FordMotorCredit]: [LienholderRequirement.Ssn],
};
